import { CompanyConfig, CompanyType } from '@floori/models';
import { bonaAdditions, bonaCustomHeader } from './bona-additions';

export const configWrapper = (
    config: CompanyConfig,
    vendorId: string,
    bonaAdditionsIds: string,
    bonaCustomHeaderIds: string,
): CompanyConfig => {
    const addBonaAdditions = bonaAdditionsIds.split(',').includes(vendorId);
    const addBonaCustomHeader = bonaCustomHeaderIds.split(',').includes(vendorId);

    if (addBonaAdditions && addBonaCustomHeader) {
        return {
            ...config,
            ...bonaAdditions(config),
            ...bonaCustomHeader(config),
        };
    }

    if (addBonaAdditions) {
        return {
            ...config,
            ...bonaAdditions(config),
        };
    }

    if (addBonaCustomHeader) {
        return {
            ...config,
            ...bonaCustomHeader(config),
        };
    }

    // TODO: Think how to extend config with translationScope. Hardcoded for Bona
    if (config.companyType === CompanyType.epoxy) {
        return {
            ...config,
            dynamicFeatures: {
                ...config.dynamicFeatures,
                ...getMarketingHeaders(config),
            },
        };
    }

    return {
        ...config,
        dynamicFeatures: {
            ...config.dynamicFeatures,
            ...getMarketingHeaders(config),
        },
    };
};

const getMarketingHeaders = (config: CompanyConfig) => {
    if (!config.header?.customHeaderEnabled) {
        return {};
    }

    return {
        marketingHeader1: config.header?.titleBlack,
        marketingHeader2: config.header?.titleColored,
        marketingSubHeader: config.header?.subTitle,
    };
};
